import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { SurveyModule } from 'survey-angular-ui';
import { SurveyCreatorModule } from 'survey-creator-angular';
import { DisplaySurveyComponent } from './components/display-survey/display-survey.component';
import { EditSurveyComponent } from './components/edit-survey/edit-survey.component';
import { ManageSurveysComponent } from './components/manage-surveys/manage-surveys.component';
import { NewSurveyComponent } from './components/new-survey/new-survey.component';
import { SurveyCreatorComponent } from './components/survey-creator/survey-creator.component';
import { SurveyListComponent } from './components/survey-list/survey-list.component';
import { SurveyResultsDashboardComponent } from './components/survey-results-dashboard/survey-results-dashboard.component';
import { SurveyResultsTableComponent } from './components/survey-results-table/survey-results-table.component';
import { SurveyResultsComponent } from './components/survey-results/survey-results.component';

@NgModule({
  declarations: [
    DisplaySurveyComponent,
    EditSurveyComponent,
    ManageSurveysComponent,
    NewSurveyComponent,
    SurveyListComponent,
    SurveyCreatorComponent,
    SurveyResultsComponent,
    SurveyResultsDashboardComponent,
    SurveyResultsTableComponent
  ],
  exports: [DisplaySurveyComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    SurveyModule,
    SurveyCreatorModule
  ]
})
export class SurveysModule {}
